<template>
  <img :src="src" :style="mystyle" :class="classes" />
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
  props: ['mystyle', 'src'],
};
</script>
